export enum EndOfEmploymentSettlementFieldLabels {
  BALANCE_HOURS = 'balanceHours'
}
